import { Link } from "react-router-dom";
import { Linkedin, Facebook, Mail, Phone, ArrowRight } from "lucide-react";
import { LOGO } from "../lib/api";
import { SOLUTIONS } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-[#808080]/20">
      <div className="container-x mx-auto max-w-[1400px] py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <img src={LOGO} alt="DNA Finance" className="h-14 w-auto object-contain mb-6" />
            <p className="text-grey text-sm leading-relaxed max-w-xs">UK commercial finance brokerage with access to 165+ lenders. The right funding, the right lender, the right solution.</p>
            <div className="flex gap-3 mt-6">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/company/dna-finance-ltd/" },
                { Icon: Facebook, href: "https://www.facebook.com/share/1CAySng6Hu/?mibextid=wwXIfr" },
                { Icon: Mail, href: "mailto:Admin@DNAfinance.co.uk" },
              ].map(({ Icon, href }, i) => (
                <a key={href} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel={href.startsWith("http") ? "noreferrer" : undefined} data-testid={`footer-social-${i}`} className="w-10 h-10 border border-[#808080]/30 flex items-center justify-center text-white/70 hover:border-lime hover:text-lime transition-colors">
                  <Icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-xs uppercase tracking-widest text-lime mb-5">Quick Links</h4>
            <ul className="space-y-3 text-sm text-grey">
              {[["Home", "/"], ["Business Finance", "/business-finance"], ["About", "/about"], ["Knowledge Hub", "/knowledge-hub"], ["Book a Call", "/booking"], ["Contact", "/contact"]].map(([l, t]) => (
                <li key={l}><Link to={t} className="hover:text-lime transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-lime mb-5">Funding Solutions</h4>
            <ul className="space-y-3 text-sm text-grey">
              {SOLUTIONS.slice(0, 6).map((s) => (
                <li key={s.slug}><Link to={`/solutions/${s.slug}`} className="hover:text-lime transition-colors">{s.title}</Link></li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs uppercase tracking-widest text-lime mb-5">Get in touch</h4>
            <p className="text-grey text-sm mb-4">Speak to a commercial finance specialist. No obligation, no jargon.</p>
            <Link to="/contact?src=footer" data-testid="footer-get-funding" className="inline-flex items-center gap-2 bg-lime text-[#1A1A1A] font-bold px-5 py-3 text-sm hover:glow-lime transition-shadow">Get Funding <ArrowRight className="w-4 h-4" /></Link>
            <div className="mt-6 space-y-2 text-sm text-grey">
              <a href="tel:+441792677652" className="flex items-center gap-2 hover:text-lime"><Phone className="w-4 h-4" /> 01792 677652</a>
              <a href="mailto:Admin@DNAfinance.co.uk" className="flex items-center gap-2 hover:text-lime"><Mail className="w-4 h-4" /> Admin@DNAfinance.co.uk</a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#808080]/20 flex flex-col md:flex-row justify-between gap-4 text-xs text-grey">
          <p>© {new Date().getFullYear()} DNA Finance. All rights reserved. Company number 16322517. ICO registration number ZC234972. DNA Finance is a commercial finance broker, not a lender.</p>
          <div className="flex gap-6">
            {[["Privacy", "/privacy"], ["Terms", "/terms"], ["Complaints", "/complaints"], ["Cookie Policy", "/cookies"]].map(([l, t]) => (
              <Link key={l} to={t} className="hover:text-lime transition-colors">{l}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
